import { Box } from '@material-ui/core';
import { useState } from 'react';

import { AssessmentFailureReasonsDialog } from '@/components/modules/Risk/RiskScore/components/AssessmentFailureReasonsDialog';
import { RiskAssessmentType } from '@/components/modules/Risk/RiskScore/types/RiskAssessmentType';
import { CheckResultIcon } from '@/components/shared/components/CheckResult/components/CheckResultIcon';
import { MoreActionsMenuWithIcon } from '@/components/shared/components/MoreActionsMenu/MoreActionsMenuWithIcon';
import { useDialog } from '@/components/shared/hooks/useDialog';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

export type Result = { passed: boolean; reasons: string[] };

enum AssessmentResultActions {
  CHECK_FAILED_REASONS = 'CHECK_FAILED_REASONS',
}

interface AssessmentResultProps {
  type: RiskAssessmentType;
  result?: Result | null;
}

export const AssessmentResult = ({ type, result }: AssessmentResultProps) => {
  const { opened, setOpened } = useDialog();

  const [action, setAction] = useState<AssessmentResultActions | undefined>(undefined);

  const AssessmentResultsActions = [
    ...(result
      ? [
          {
            display: <Text tId={'CHECK_FAILED_REASONS'} />,
            iconName: 'feedback',
            onClick: () => handleCheckFailedReasons(),
          },
        ]
      : []),
  ];

  const handleCheckFailedReasons = () => {
    setOpened(true);
    setAction(AssessmentResultActions.CHECK_FAILED_REASONS);
  };

  return (
    <>
      <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
        <Font variant="body2" color="textSecondary" style={{ marginRight: '6px' }}>
          <Text tId={result?.passed === false ? 'RISK_SCORE_FAILED' : result ? 'PASSED' : 'PENDING'} />
        </Font>
        <CheckResultIcon passed={result?.passed} boxProps={{ marginRight: 0 }} />
        {result?.passed === false && (
          <MoreActionsMenuWithIcon
            actionsOptionsArray={AssessmentResultsActions}
            iconButtonProps={{ style: { padding: 0 } }}
          />
        )}
      </Box>
      {result && action === AssessmentResultActions.CHECK_FAILED_REASONS && (
        <AssessmentFailureReasonsDialog opened={opened} setOpened={setOpened} result={result} type={type} />
      )}
    </>
  );
};
